import { LitElement, html, css, unsafeCSS } from 'lit';
import { RDPropsetContainer } from '../Container/PropContainer.js';

import styles from './Color.css?raw';

export class propColor extends RDPropsetContainer {
  static styles = [
    super.styles,
    css`
      ${unsafeCSS(styles)}
    `,
  ];
  static properties = {
    value: { type: String },
    disabled: { type: Boolean, reflect: true },
    placeholder: { type: String },
    onInput: { type: Function },
    onChange: { type: Function },
    callback: { type: Function },
    type: { type: String, reflect: true },
  };
  constructor() {
    super();
    this.value = 'black';
    this.disabled = false;
    this.placeholder = 'auto';
    this.onInput = null;
    this.onChange = null;
    this.callback = null;
    this.type = 'input'; //input | picker
    this.picker = null;
    this._tempValue = this.value;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
  }
  _inputChanged(e) {
    const newValue = e.target.value;
    this.value = newValue;
    if (this.onInput && typeof this.onInput === 'function') {
      this.onInput.bind(this)(newValue);
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(newValue);
    }
    this.requestUpdate();
  }
  _onInput(e) {
    const newValue = e.target.value;
    this.value = newValue;
    if (this.onInput && typeof this.onInput === 'function') {
      this.onInput.bind(this)(newValue);
    }
    if (this.callback && typeof this.callback === 'function') {
      this.callback.bind(this)(newValue);
    }
    if (this.picker && this.picker.value !== newValue) {
      this.picker.value = newValue;
    }
    this.requestUpdate();
  }
  _openColorPicker() {
    const target = this.type === 'picker' ? this.renderRoot.querySelector('.color-container.picker') : this.renderRoot.querySelector('.prop-body');
    this._tempValue = this.value;
    this.picker = ColorPicker.show({
      target: target,
      value: this.value,
      placement: 'right',
      onColorChange: (color) => {
        if (this.onInput && typeof this.onInput === 'function') {
          this.onInput.bind(this)(color);
        }
        if (this.callback && typeof this.callback === 'function') {
          this.callback.bind(this)(color);
        }
        this.value = color;
        this.requestUpdate();
      },
      onClose: () => {
        //to be checked
        if (this.onChange && typeof this.onChange === 'function') {
          if (this.value !== this._tempValue) {
            this._tempValue = this.value;
            this.onChange.bind(this)(this.value);
          }
        }
        // this.picker = null;
      },
    });
  }
  renderBody() {
    return html`
      <div class="color-container ${this.type != 'input' ? 'picker' : ''}" @click="${() => this._openColorPicker()}">
        <div class="color" style="background-color: ${this.value || '#000000'};"></div>
        <input type="text" value="${this.value}" @change="${this._inputChanged}" @input="${this._onInput}" />
      </div>
    `;
  }
}
if (!customElements.get('rd-prop-color')) {
  customElements.define('rd-prop-color', propColor);
}
